
$models.favouriteFolders = {

	getItem : function($folderid, $callback) {
		// proxy to same function in folders model, since it doesn't really make sense to have a separate API method available for this, even though the UI might require this function to be present
		$models.folders.getItem($folderid, $callback);
	},

	getList : function($params, $callback) {
		if ($models.favouriteFolders.currentGetListAjaxRequest) {
			$models.favouriteFolders.currentGetListAjaxRequest.abort();
		}
		$models.favouriteFolders.currentGetListAjaxRequest = $models.all.getDataFromAPI('favourite_folders.json', $params, function($data) {
		// TODO: remove this jQuery.each(), once the necessary data is returning correctly from the API
			jQuery.each($data.folders, function($key, $folder) {
				$data.folders[$key].favourited = true;
			});
			$callback($data);
		}, 'Unable to load the list of favourite folders');
	},

	getListWithOffset : function($params, $callback) {
		$params = ($params || {});
		$models.favouriteFolders.getList($params, $callback);
	},

	getSize : function($callback) {
		$models.favouriteFolders.getList({}, function($data) {
			$callback($data.result_count);
		});
	},

	setItem : function($folderid, $callback, $callbackError) {
		$models.all.getDataFromAPI('favourite_folders.json', {folder_ids: $folderid}, function($data) {
			$callback($data);
			$cached.folders.dataHasChanged();
		}, function($error) {
			if ($callbackError) {
				$callbackError($error);
            }
      		$soupmail.modal.raise($error.error);
		}, 'POST');
	},

	deleteItem : function($folderid, $callback) {
		$models.all.getDataFromAPI('favourite_folders.json', {folder_ids: $folderid}, function($data) {
			$callback($data);
			$cached.folders.dataHasChanged();
		}, 'Unable to remove folder from favourites', 'DELETE');
	},

	isEditable : function($folder) {
		// proxy to same function in folders model, since the UI might require this function to be present, even though there is duplication
		return $models.folders.isEditable($folderIsEditable);
	},

	isAjaxRequestInProgress : function() {
		if (!$models.favouriteFolders.currentGetListAjaxRequest) { return false; }
		if ($models.favouriteFolders.currentGetListAjaxRequest.status > 100) { return false; }
		return true;
	}

};



// WEBPACK FOOTER //
// ./src/js/models/favouritefolders.js